<template>
    <div v-show="editShow">
        <div class="container">
            <el-row :gutter="20">
                <div class="clearfix">
                    <div class="crumbs">
                        <i class="el-icon-back"></i>
                        <el-button type="text" @click="goBack">返回</el-button>
                    </div>
                    <div class="btn-save">
                        <el-button type="primary" @click="saveClick('formData')"
                        >保存
                        </el-button
                        >
                    </div>
                </div>
                <div class="form-box">
                    <el-form
                            :model="formData"
                            :rules="rules"
                            ref="formData"
                            label-width="120px"
                            class="eidt-el-form"
                    >
                        <el-form-item label="酒店" prop="projectHotelId">
                            <el-select
                                    v-model="formData.projectHotelId"
                                    placeholder="请选择酒店"
                            >
                                <el-option
                                        v-for="(type, index) in projectHotel"
                                        :label="type.name"
                                        :key="index"
                                        :value="type.projectHotelId"
                                >
                                    <div @click="changeHotel(type)">{{ type.name }}</div>
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="类型" prop="projectHotelId">
                            <el-select
                                    v-model="formData.projectRoomTypeId"
                                    placeholder="请选择酒店"
                            >
                                <el-option
                                        v-for="(type, index) in projectRoomType"
                                        :label="type.name"
                                        :key="index"
                                        :value="type.projectRoomTypeId"
                                >
                                    <div @click="getChangeType(type)">{{ type.name }}</div>
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="房间" prop="projectRoomId">
                            <el-select
                                    v-model="formData.projectRoomId"
                                    placeholder="请选择房间"
                            >
                                <el-option
                                        v-for="(type, index) in projectRoom"
                                        :label="type.roomNo"
                                        :key="index"
                                        :value="type.projectRoomId"
                                >
                                    <div @click="getChangeRoom(type)">{{ type.roomNo }}</div>
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="开始时间" prop="startDate">
                            <el-date-picker
                                    v-model="formData.startDate"
                                    type="datetime"
                                    placeholder="开始日期"
                            ></el-date-picker>
                        </el-form-item>
                        <el-form-item label="结束时间" prop="endDate">
                            <el-date-picker
                                    v-model="formData.endDate"
                                    type="datetime"
                                    placeholder="结束日期"
                            ></el-date-picker>
                        </el-form-item>
                        <el-form-item label="姓名" prop="name">
                            <el-input v-model="formData.name"></el-input>
                        </el-form-item>
                        <el-form-item label="身份证" prop="idCard">
                            <el-input v-model="formData.idCard"></el-input>
                        </el-form-item>
                        <el-form-item label="是否入住" prop="allocation">
                            <el-radio-group v-model="formData.allocation">
                                <el-radio :label="true">已入住</el-radio>
                                <el-radio :label="false">未入住</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-form>
                </div>
            </el-row>
        </div>
    </div>
</template>

<script>
    import bus from "../common/bus";

    export default {
        name: "edit_project_room_record",
        data() {
            return {
                rules: {
                    projectRoomId: [{required: true, message: "请选择房间", trigger: "blur"}],
                    projectHotelId: [
                        {required: true, message: "请选择酒店", trigger: "blur"},
                    ],
                    projectRoomTypeId: [
                        {required: true, message: "请选择房间类型", trigger: "blur"},
                    ],
                    name: [{required: true, message: "姓名不能为空", trigger: "blur"}],
                    idCard: [{required: true, message: "身份证不能为空", trigger: "blur"}],
                    startDate: [{required: true, message: "开始时间不能为空", trigger: "blur"}],
                    endDate: [{required: true, message: "结束时间不能为空", trigger: "blur"}],
                },
                formData: {
                    name: "",
                    idCard: "",
                    type: "",
                    roomNo: "",
                    startDate: null,
                    endDate: null,
                    allocation: false,
                    projectRoomId: null,
                    projectHotelId: null,
                    projectRoomTypeId: null,
                    projectId: localStorage.getItem("project_Id"),
                    documentId: "",
                    personalId: ""
                },
                projectHotelId: null,
                projectRoomRecordId: "",
                admin: "",
                projectHotel: [],
                projectRoomType: [],
                projectRoom: [],
                project_Id: localStorage.getItem("project_Id"),
            };
        },
        props: {
            editShow: {
                type: Boolean,
                default: false,
            },
            arrarList: {
                type: Array,
                default() {
                    return [];
                },
            },
            editData: {
                type: Object,
            },
        },
        watch: {
            editData: function () {
                const item = this.editData;
                if (item) {
                    this.formData = item;
                    this.projectRoomId = item.projectRoomId;
                    this.projectHotelId = item.projectHotelId;
                    this.projectRoomRecordId = item.projectRoomRecordId;
                    this.getProjectRoomType();
                }
            },
        },
        created() {
            bus.$on("getPTypeId", (message) => {
                this.projectHotelId = message;
            });
            this.getProjectHotel();
        },
        methods: {
            getProjectHotel() {
                this.$axios.get("/ProjectHotel/Project/" + this.project_Id).then((res) => {
                    if (res.data.hasError == false) {
                        this.projectHotel = [...res.data.data];
                        this.getProjectRoomType();
                    }
                });
            },
            getProjectRoomType() {
                if (!this.projectHotelId) {
                    return
                }
                this.$axios.get("/ProjectRoomType/Hotel/" + this.projectHotelId).then((res) => {
                    if (res.data.hasError == false) {
                        this.projectRoomType = [...res.data.data];
                        this.getProjectRoom();
                    }
                });
            },
            getProjectRoom() {
                if (!this.formData.projectRoomTypeId) {
                    return
                }
                this.$axios.get("/ProjectRoom/Type/" + this.formData.projectRoomTypeId).then((res) => {
                    if (res.data.hasError == false) {
                        this.projectRoom = [...res.data.data];
                    }
                });
            },
            changeHotel(type) {
                this.projectHotelId = type.projectHotelId;
                this.formData.projectRoomTypeId = null;
                this.formData.projectRoomId = null;
                this.getProjectRoomType();
            },
            getChangeType(type) {
                this.formData.type = type.name;
                this.formData.projectRoomId = null;
                this.formData.projectRoomTypeId = type.projectRoomTypeId;
                this.getProjectRoom();
            },
            getChangeRoom(room) {
                this.formData.roomNo = room.roomNo;
                this.formData.type = room.type;
            },
            saveClick(formData) {
                this.formData.projectId = this.project_Id;
                var state_date = null;
                if (this.formData.startDate) {
                    try {
                        var s = new Date(this.formData.startDate);
                        state_date = s.getFullYear() +
                            "-" +
                            (s.getMonth() + 1) +
                            "-" +
                            (s.getDate() < 10 ? "0" + s.getDate() : s.getDate()) +
                            " " +
                            s.getHours() +
                            ":" +
                            s.getMinutes() +
                            ":" +
                            s.getSeconds();
                    } catch (e) {
                        startDate = this.formData.startDate;
                    }
                }

                var end_date = null;
                if (this.formData.endDate) {
                    try {
                        var e = new Date(this.formData.endDate);
                        end_date = e.getFullYear() +
                            "-" +
                            (e.getMonth() + 1) +
                            "-" +
                            (e.getDate() < 10 ? "0" + e.getDate() : e.getDate()) +
                            " " +
                            e.getHours() +
                            ":" +
                            e.getMinutes() +
                            ":" +
                            e.getSeconds();
                    } catch (e) {
                        end_date = this.formData.endDate;
                    }
                }
                this.formData.startDate = state_date;
                this.formData.endDate = end_date;

                this.$refs[formData].validate((valid) => {
                    if (valid) {
                        if (!this.projectRoomRecordId) {
                            this.$axios.post("/ProjectRoomRecord/", this.formData).then((res) => {
                                if (res.data.hasError == false) {
                                    this.$message.success("保存成功！");
                                    this.$refs[formData].resetFields();
                                    this.goBack();
                                } else {

                                  this.$message.error(res.data.message);
                                }
                            });
                        } else {
                            this.$axios
                                .put("/ProjectRoomRecord/" + this.projectRoomRecordId, this.formData)
                                .then((res) => {
                                    if (res.data.hasError == false) {
                                        this.$message.success("编辑成功！");
                                        this.$refs[formData].resetFields();
                                        this.goBack();
                                    } else {

                                      this.$message.error(res.data.message);                                    }
                                });
                        }
                    } else {
                        return false;
                    }
                });
            },
            goBack() {
                this.projectRoomRecordId = "";
                this.admin = "";
                this.editImg = "";
                this.editImg1 = "";
                this.$emit("backFunStu");
                this.$refs["formData"].resetFields();
            },
        }
    };
</script>

<style lang="scss">
    .container {
        margin-bottom: 10px;
    }

    .el-inpt-phone {
        width: calc(100% - 70px);
    }

    .jc-btn {
        position: absolute;
        width: 60px;
        right: 0;
    }
</style>